import type { PropsWithChildren } from "react";

export const LeftContainer = ({ children }: PropsWithChildren<unknown>) => (
  <div className="flex w-full items-center justify-between">{children}</div>
);
